import Prefecture from '@/components/react-hook-form/Prefecture';
import RegisterLayout from '../components/RegisterLayout';
import { useFormContext, Controller } from 'react-hook-form';
import type { FormSchema } from '@/app/register/schema';
import { prefectures } from '@/constants/prefecture';
import { SelectItem } from '@/components/shadcn/Select';
import { useMemo } from 'react';
import { registerTextStyle } from '@/app/register/constants';
import { buildUpdateUserProfileParams } from '../functions';
import { updateUserProfile } from '../../../actions/user';
import FirebasePageViewEvent from '@/components/firebase/PageViewEvent';
import { EVENTS } from '@/lib/firebase/analytics/events';

export const createPrefectureOptions = () =>
  prefectures.map(({ id, name }) => (
    <SelectItem key={id} value={String(id)}>
      {name}
    </SelectItem>
  ));

export default function PrefectureForm() {
  const { watch, control } = useFormContext<FormSchema>();

  const prefectureElements = useMemo(createPrefectureOptions, []);

  const updatePrefecture = () => {
    const prefecture = watch('prefecture');
    const params = buildUpdateUserProfileParams({ prefecture });
    return updateUserProfile(params);
  };

  return (
    <>
      <div>
        <h3 className={registerTextStyle}>
          <span className="text-[20px] text-[#231717]">お住まいの都道府県</span>
          を教えてください
        </h3>
        <RegisterLayout
          prev="birthday"
          next="workplace"
          disabled={!watch('prefecture')}
          updateProfile={updatePrefecture}
        >
          <div className="mx-auto mt-[24px] max-w-[672px]">
            <Controller
              control={control}
              name="prefecture"
              render={({ field: { value, onChange } }) => (
                <Prefecture
                  value={value}
                  onChange={onChange}
                  optionElements={prefectureElements}
                  placeholder="都道府県を選択してください"
                  className="w-full"
                />
              )}
            />
          </div>
        </RegisterLayout>
      </div>

      {/* Firebaseイベント発火 */}
      <FirebasePageViewEvent
        eventName={EVENTS.registration_prefecture_display}
      />
    </>
  );
}
